import { getDefaultRsyncConfig, IRsyncConfig } from './rsync/IRsyncConfig';
import { IrisModContainer, IIrisModContainerConstParam } from './IrisModContainer';
import { IrisConfigContainer, IIrisConfigContainerConstParam } from './IrisConfigContainer';
import deepmerge from 'deepmerge';


export class IrisrawModRsync extends IrisModContainer<IrisConfigContainer<IRsyncConfig>> {
                
    constructor({...args }:IIrisModContainerConstParam = {} as IIrisModContainerConstParam) {
        super(args,IrisrawModRsync.createIrisrawModRsyncConfig)        
    }

    static createIrisrawModRsync(datas:IIrisModContainerConstParam) {        
        return new IrisrawModRsync(datas)
    }

    static createIrisrawModRsyncConfig(data:IIrisConfigContainerConstParam) {                
        return new IrisConfigContainer<IRsyncConfig>(deepmerge( {mod_settings:getDefaultRsyncConfig()},data))
    }

} 